import _toArray from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/toArray";
import _createClass from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _slicedToArray from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
var _excluded = ["message"];
import _regeneratorRuntime from "/opt/buildhome/repo/node_modules/@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(toFailures),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(run);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * A `StructFailure` represents a single specific failure in validation.
 */

/**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */
var StructError = /*#__PURE__*/function (_TypeError) {
  _inherits(StructError, _TypeError);

  var _super = _createSuper(StructError);

  function StructError(failure, failures) {
    var _this;

    _classCallCheck(this, StructError);

    var cached;

    var message = failure.message,
        rest = _objectWithoutProperties(failure, _excluded);

    var path = failure.path;
    var msg = path.length === 0 ? message : "At path: " + path.join('.') + " -- " + message;
    _this = _super.call(this, msg);
    Object.assign(_assertThisInitialized(_this), rest);
    _this.name = _this.constructor.name;

    _this.failures = function () {
      var _cached;

      return (_cached = cached) != null ? _cached : cached = [failure].concat(_toConsumableArray(failures()));
    };

    return _this;
  }

  return StructError;
}( /*#__PURE__*/_wrapNativeSuper(TypeError));
/**
 * Check if a value is an iterator.
 */


function isIterable(x) {
  return isObject(x) && typeof x[Symbol.iterator] === 'function';
}
/**
 * Check if a value is a plain object.
 */


function isObject(x) {
  return typeof x === 'object' && x != null;
}
/**
 * Check if a value is a plain object.
 */


function isPlainObject(x) {
  if (Object.prototype.toString.call(x) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(x);
  return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */


function print(value) {
  return typeof value === 'string' ? JSON.stringify(value) : "" + value;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */


function shiftIterator(input) {
  var _input$next = input.next(),
      done = _input$next.done,
      value = _input$next.value;

  return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */


function toFailure(result, context, struct, value) {
  if (result === true) {
    return;
  } else if (result === false) {
    result = {};
  } else if (typeof result === 'string') {
    result = {
      message: result
    };
  }

  var path = context.path,
      branch = context.branch;
  var type = struct.type;
  var _result = result,
      refinement = _result.refinement,
      _result$message = _result.message,
      message = _result$message === void 0 ? "Expected a value of type `" + type + "`" + (refinement ? " with refinement `" + refinement + "`" : '') + ", but received: `" + print(value) + "`" : _result$message;
  return _objectSpread(_objectSpread({
    value: value,
    type: type,
    refinement: refinement,
    key: path[path.length - 1],
    path: path,
    branch: branch
  }, result), {}, {
    message: message
  });
}
/**
 * Convert a validation result to an iterable of failures.
 */


function toFailures(result, context, struct, value) {
  var _iterator, _step, r, failure;

  return _regeneratorRuntime.wrap(function toFailures$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!isIterable(result)) {
            result = [result];
          }

          _iterator = _createForOfIteratorHelper(result);
          _context.prev = 2;

          _iterator.s();

        case 4:
          if ((_step = _iterator.n()).done) {
            _context.next = 12;
            break;
          }

          r = _step.value;
          failure = toFailure(r, context, struct, value);

          if (!failure) {
            _context.next = 10;
            break;
          }

          _context.next = 10;
          return failure;

        case 10:
          _context.next = 4;
          break;

        case 12:
          _context.next = 17;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](2);

          _iterator.e(_context.t0);

        case 17:
          _context.prev = 17;

          _iterator.f();

          return _context.finish(17);

        case 20:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[2, 14, 17, 20]]);
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */


function run(value, struct) {
  var options,
      _options$path,
      path,
      _options$branch,
      branch,
      _options$coerce,
      coerce,
      _options$mask,
      mask,
      ctx,
      key,
      valid,
      _iterator2,
      _step2,
      _failure,
      _iterator3,
      _step3,
      _step3$value,
      k,
      v,
      s,
      ts,
      _iterator5,
      _step5,
      t,
      _iterator4,
      _step4,
      failure,
      _args2 = arguments;

  return _regeneratorRuntime.wrap(function run$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          options = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
          _options$path = options.path, path = _options$path === void 0 ? [] : _options$path, _options$branch = options.branch, branch = _options$branch === void 0 ? [value] : _options$branch, _options$coerce = options.coerce, coerce = _options$coerce === void 0 ? false : _options$coerce, _options$mask = options.mask, mask = _options$mask === void 0 ? false : _options$mask;
          ctx = {
            path: path,
            branch: branch
          };

          if (coerce) {
            value = struct.coercer(value, ctx);

            if (mask && struct.type !== 'type' && isObject(struct.schema) && isObject(value) && !Array.isArray(value)) {
              for (key in value) {
                if (struct.schema[key] === undefined) {
                  delete value[key];
                }
              }
            }
          }

          valid = true;
          _iterator2 = _createForOfIteratorHelper(struct.validator(value, ctx));
          _context2.prev = 6;

          _iterator2.s();

        case 8:
          if ((_step2 = _iterator2.n()).done) {
            _context2.next = 15;
            break;
          }

          _failure = _step2.value;
          valid = false;
          _context2.next = 13;
          return [_failure, undefined];

        case 13:
          _context2.next = 8;
          break;

        case 15:
          _context2.next = 20;
          break;

        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2["catch"](6);

          _iterator2.e(_context2.t0);

        case 20:
          _context2.prev = 20;

          _iterator2.f();

          return _context2.finish(20);

        case 23:
          _iterator3 = _createForOfIteratorHelper(struct.entries(value, ctx));
          _context2.prev = 24;

          _iterator3.s();

        case 26:
          if ((_step3 = _iterator3.n()).done) {
            _context2.next = 53;
            break;
          }

          _step3$value = _slicedToArray(_step3.value, 3), k = _step3$value[0], v = _step3$value[1], s = _step3$value[2];
          ts = run(v, s, {
            path: k === undefined ? path : [].concat(_toConsumableArray(path), [k]),
            branch: k === undefined ? branch : [].concat(_toConsumableArray(branch), [v]),
            coerce: coerce,
            mask: mask
          });
          _iterator5 = _createForOfIteratorHelper(ts);
          _context2.prev = 30;

          _iterator5.s();

        case 32:
          if ((_step5 = _iterator5.n()).done) {
            _context2.next = 43;
            break;
          }

          t = _step5.value;

          if (!t[0]) {
            _context2.next = 40;
            break;
          }

          valid = false;
          _context2.next = 38;
          return [t[0], undefined];

        case 38:
          _context2.next = 41;
          break;

        case 40:
          if (coerce) {
            v = t[1];

            if (k === undefined) {
              value = v;
            } else if (value instanceof Map) {
              value.set(k, v);
            } else if (value instanceof Set) {
              value.add(v);
            } else if (isObject(value)) {
              value[k] = v;
            }
          }

        case 41:
          _context2.next = 32;
          break;

        case 43:
          _context2.next = 48;
          break;

        case 45:
          _context2.prev = 45;
          _context2.t1 = _context2["catch"](30);

          _iterator5.e(_context2.t1);

        case 48:
          _context2.prev = 48;

          _iterator5.f();

          return _context2.finish(48);

        case 51:
          _context2.next = 26;
          break;

        case 53:
          _context2.next = 58;
          break;

        case 55:
          _context2.prev = 55;
          _context2.t2 = _context2["catch"](24);

          _iterator3.e(_context2.t2);

        case 58:
          _context2.prev = 58;

          _iterator3.f();

          return _context2.finish(58);

        case 61:
          if (!valid) {
            _context2.next = 80;
            break;
          }

          _iterator4 = _createForOfIteratorHelper(struct.refiner(value, ctx));
          _context2.prev = 63;

          _iterator4.s();

        case 65:
          if ((_step4 = _iterator4.n()).done) {
            _context2.next = 72;
            break;
          }

          failure = _step4.value;
          valid = false;
          _context2.next = 70;
          return [failure, undefined];

        case 70:
          _context2.next = 65;
          break;

        case 72:
          _context2.next = 77;
          break;

        case 74:
          _context2.prev = 74;
          _context2.t3 = _context2["catch"](63);

          _iterator4.e(_context2.t3);

        case 77:
          _context2.prev = 77;

          _iterator4.f();

          return _context2.finish(77);

        case 80:
          if (!valid) {
            _context2.next = 83;
            break;
          }

          _context2.next = 83;
          return [undefined, value];

        case 83:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[6, 17, 20, 23], [24, 55, 58, 61], [30, 45, 48, 51], [63, 74, 77, 80]]);
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */


var Struct = /*#__PURE__*/function () {
  function Struct(props) {
    var _this2 = this;

    _classCallCheck(this, Struct);

    var type = props.type,
        schema = props.schema,
        validator = props.validator,
        refiner = props.refiner,
        _props$coercer = props.coercer,
        coercer = _props$coercer === void 0 ? function (value) {
      return value;
    } : _props$coercer,
        _props$entries = props.entries,
        entries = _props$entries === void 0 ? /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee);
    }) : _props$entries;
    this.type = type;
    this.schema = schema;
    this.entries = entries;
    this.coercer = coercer;

    if (validator) {
      this.validator = function (value, context) {
        var result = validator(value, context);
        return toFailures(result, context, _this2, value);
      };
    } else {
      this.validator = function () {
        return [];
      };
    }

    if (refiner) {
      this.refiner = function (value, context) {
        var result = refiner(value, context);
        return toFailures(result, context, _this2, value);
      };
    } else {
      this.refiner = function () {
        return [];
      };
    }
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */


  _createClass(Struct, [{
    key: "assert",
    value: function assert(value) {
      return _assert(value, this);
    }
    /**
     * Create a value with the struct's coercion logic, then validate it.
     */

  }, {
    key: "create",
    value: function create(value) {
      return _create(value, this);
    }
    /**
     * Check if a value passes the struct's validation.
     */

  }, {
    key: "is",
    value: function is(value) {
      return _is(value, this);
    }
    /**
     * Mask a value, coercing and validating it, but returning only the subset of
     * properties defined by the struct's schema.
     */

  }, {
    key: "mask",
    value: function mask(value) {
      return _mask(value, this);
    }
    /**
     * Validate a value with the struct's validation logic, returning a tuple
     * representing the result.
     *
     * You may optionally pass `true` for the `withCoercion` argument to coerce
     * the value before attempting to validate it. If you do, the result will
     * contain the coerced result when successful.
     */

  }, {
    key: "validate",
    value: function validate(value) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _validate(value, this, options);
    }
  }]);

  return Struct;
}();
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */


function _assert(value, struct) {
  var result = _validate(value, struct);

  if (result[0]) {
    throw result[0];
  }
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */


function _create(value, struct) {
  var result = _validate(value, struct, {
    coerce: true
  });

  if (result[0]) {
    throw result[0];
  } else {
    return result[1];
  }
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */


function _mask(value, struct) {
  var result = _validate(value, struct, {
    coerce: true,
    mask: true
  });

  if (result[0]) {
    throw result[0];
  } else {
    return result[1];
  }
}
/**
 * Check if a value passes a struct.
 */


function _is(value, struct) {
  var result = _validate(value, struct);

  return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */


function _validate(value, struct) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var tuples = run(value, struct, options);
  var tuple = shiftIterator(tuples);

  if (tuple[0]) {
    var error = new StructError(tuple[0], /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _iterator6, _step6, t;

      return _regeneratorRuntime.wrap(function _callee2$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _iterator6 = _createForOfIteratorHelper(tuples);
              _context4.prev = 1;

              _iterator6.s();

            case 3:
              if ((_step6 = _iterator6.n()).done) {
                _context4.next = 10;
                break;
              }

              t = _step6.value;

              if (!t[0]) {
                _context4.next = 8;
                break;
              }

              _context4.next = 8;
              return t[0];

            case 8:
              _context4.next = 3;
              break;

            case 10:
              _context4.next = 15;
              break;

            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](1);

              _iterator6.e(_context4.t0);

            case 15:
              _context4.prev = 15;

              _iterator6.f();

              return _context4.finish(15);

            case 18:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee2, null, [[1, 12, 15, 18]]);
    }));
    return [error, undefined];
  } else {
    var v = tuple[1];
    return [undefined, v];
  }
}

function assign() {
  for (var _len = arguments.length, Structs = new Array(_len), _key = 0; _key < _len; _key++) {
    Structs[_key] = arguments[_key];
  }

  var schemas = Structs.map(function (s) {
    return s.schema;
  });
  var schema = Object.assign.apply(Object, [{}].concat(_toConsumableArray(schemas)));
  return object(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */


function define(name, validator) {
  return new Struct({
    type: name,
    schema: null,
    validator: validator
  });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */


function deprecated(struct, log) {
  return new Struct(_objectSpread(_objectSpread({}, struct), {}, {
    refiner: function refiner(value, ctx) {
      return value === undefined || struct.refiner(value, ctx);
    },
    validator: function validator(value, ctx) {
      if (value === undefined) {
        return true;
      } else {
        log(value, ctx);
        return struct.validator(value, ctx);
      }
    }
  }));
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */


function dynamic(fn) {
  return new Struct({
    type: 'dynamic',
    schema: null,
    entries: /*#__PURE__*/_regeneratorRuntime.mark(function entries(value, ctx) {
      var struct;
      return _regeneratorRuntime.wrap(function entries$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              struct = fn(value, ctx);
              return _context5.delegateYield(struct.entries(value, ctx), "t0", 2);

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, entries);
    }),
    validator: function validator(value, ctx) {
      var struct = fn(value, ctx);
      return struct.validator(value, ctx);
    },
    coercer: function coercer(value, ctx) {
      var struct = fn(value, ctx);
      return struct.coercer(value, ctx);
    }
  });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */


function lazy(fn) {
  var struct;
  return new Struct({
    type: 'lazy',
    schema: null,
    entries: /*#__PURE__*/_regeneratorRuntime.mark(function entries(value, ctx) {
      var _struct;

      return _regeneratorRuntime.wrap(function entries$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              (_struct = struct) != null ? _struct : struct = fn();
              return _context6.delegateYield(struct.entries(value, ctx), "t0", 2);

            case 2:
            case "end":
              return _context6.stop();
          }
        }
      }, entries);
    }),
    validator: function validator(value, ctx) {
      var _struct2;

      (_struct2 = struct) != null ? _struct2 : struct = fn();
      return struct.validator(value, ctx);
    },
    coercer: function coercer(value, ctx) {
      var _struct3;

      (_struct3 = struct) != null ? _struct3 : struct = fn();
      return struct.coercer(value, ctx);
    }
  });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */


function omit(struct, keys) {
  var schema = struct.schema;

  var subschema = _objectSpread({}, schema);

  var _iterator7 = _createForOfIteratorHelper(keys),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var key = _step7.value;
      delete subschema[key];
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  return object(subschema);
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */


function partial(struct) {
  var schema = struct instanceof Struct ? _objectSpread({}, struct.schema) : _objectSpread({}, struct);

  for (var key in schema) {
    schema[key] = optional(schema[key]);
  }

  return object(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */


function pick(struct, keys) {
  var schema = struct.schema;
  var subschema = {};

  var _iterator8 = _createForOfIteratorHelper(keys),
      _step8;

  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var key = _step8.value;
      subschema[key] = schema[key];
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }

  return object(subschema);
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */


function struct(name, validator) {
  console.warn('superstruct@0.11 - The `struct` helper has been renamed to `define`.');
  return define(name, validator);
}
/**
 * Ensure that any value passes validation.
 */


function any() {
  return define('any', function () {
    return true;
  });
}

function array(Element) {
  return new Struct({
    type: 'array',
    schema: Element,
    entries: /*#__PURE__*/_regeneratorRuntime.mark(function entries(value) {
      var _iterator9, _step9, _step9$value, i, v;

      return _regeneratorRuntime.wrap(function entries$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (!(Element && Array.isArray(value))) {
                _context7.next = 18;
                break;
              }

              _iterator9 = _createForOfIteratorHelper(value.entries());
              _context7.prev = 2;

              _iterator9.s();

            case 4:
              if ((_step9 = _iterator9.n()).done) {
                _context7.next = 10;
                break;
              }

              _step9$value = _slicedToArray(_step9.value, 2), i = _step9$value[0], v = _step9$value[1];
              _context7.next = 8;
              return [i, v, Element];

            case 8:
              _context7.next = 4;
              break;

            case 10:
              _context7.next = 15;
              break;

            case 12:
              _context7.prev = 12;
              _context7.t0 = _context7["catch"](2);

              _iterator9.e(_context7.t0);

            case 15:
              _context7.prev = 15;

              _iterator9.f();

              return _context7.finish(15);

            case 18:
            case "end":
              return _context7.stop();
          }
        }
      }, entries, null, [[2, 12, 15, 18]]);
    }),
    coercer: function coercer(value) {
      return Array.isArray(value) ? value.slice() : value;
    },
    validator: function validator(value) {
      return Array.isArray(value) || "Expected an array value, but received: " + print(value);
    }
  });
}
/**
 * Ensure that a value is a boolean.
 */


function boolean() {
  return define('boolean', function (value) {
    return typeof value === 'boolean';
  });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */


function date() {
  return define('date', function (value) {
    return value instanceof Date && !isNaN(value.getTime()) || "Expected a valid `Date` object, but received: " + print(value);
  });
}

function enums(values) {
  var schema = {};
  var description = values.map(function (v) {
    return print(v);
  }).join();

  var _iterator10 = _createForOfIteratorHelper(values),
      _step10;

  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var key = _step10.value;
      schema[key] = key;
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }

  return new Struct({
    type: 'enums',
    schema: schema,
    validator: function validator(value) {
      return values.includes(value) || "Expected one of `" + description + "`, but received: " + print(value);
    }
  });
}
/**
 * Ensure that a value is a function.
 */


function func() {
  return define('func', function (value) {
    return typeof value === 'function' || "Expected a function, but received: " + print(value);
  });
}
/**
 * Ensure that a value is an instance of a specific class.
 */


function instance(Class) {
  return define('instance', function (value) {
    return value instanceof Class || "Expected a `" + Class.name + "` instance, but received: " + print(value);
  });
}
/**
 * Ensure that a value is an integer.
 */


function integer() {
  return define('integer', function (value) {
    return typeof value === 'number' && !isNaN(value) && Number.isInteger(value) || "Expected an integer, but received: " + print(value);
  });
}

function intersection(Structs) {
  return new Struct({
    type: 'intersection',
    schema: null,
    entries: /*#__PURE__*/_regeneratorRuntime.mark(function entries(value, ctx) {
      var _iterator11, _step11, S;

      return _regeneratorRuntime.wrap(function entries$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _iterator11 = _createForOfIteratorHelper(Structs);
              _context8.prev = 1;

              _iterator11.s();

            case 3:
              if ((_step11 = _iterator11.n()).done) {
                _context8.next = 8;
                break;
              }

              S = _step11.value;
              return _context8.delegateYield(S.entries(value, ctx), "t0", 6);

            case 6:
              _context8.next = 3;
              break;

            case 8:
              _context8.next = 13;
              break;

            case 10:
              _context8.prev = 10;
              _context8.t1 = _context8["catch"](1);

              _iterator11.e(_context8.t1);

            case 13:
              _context8.prev = 13;

              _iterator11.f();

              return _context8.finish(13);

            case 16:
            case "end":
              return _context8.stop();
          }
        }
      }, entries, null, [[1, 10, 13, 16]]);
    }),
    validator: /*#__PURE__*/_regeneratorRuntime.mark(function validator(value, ctx) {
      var _iterator12, _step12, S;

      return _regeneratorRuntime.wrap(function validator$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _iterator12 = _createForOfIteratorHelper(Structs);
              _context9.prev = 1;

              _iterator12.s();

            case 3:
              if ((_step12 = _iterator12.n()).done) {
                _context9.next = 8;
                break;
              }

              S = _step12.value;
              return _context9.delegateYield(S.validator(value, ctx), "t0", 6);

            case 6:
              _context9.next = 3;
              break;

            case 8:
              _context9.next = 13;
              break;

            case 10:
              _context9.prev = 10;
              _context9.t1 = _context9["catch"](1);

              _iterator12.e(_context9.t1);

            case 13:
              _context9.prev = 13;

              _iterator12.f();

              return _context9.finish(13);

            case 16:
            case "end":
              return _context9.stop();
          }
        }
      }, validator, null, [[1, 10, 13, 16]]);
    }),
    refiner: /*#__PURE__*/_regeneratorRuntime.mark(function refiner(value, ctx) {
      var _iterator13, _step13, S;

      return _regeneratorRuntime.wrap(function refiner$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _iterator13 = _createForOfIteratorHelper(Structs);
              _context10.prev = 1;

              _iterator13.s();

            case 3:
              if ((_step13 = _iterator13.n()).done) {
                _context10.next = 8;
                break;
              }

              S = _step13.value;
              return _context10.delegateYield(S.refiner(value, ctx), "t0", 6);

            case 6:
              _context10.next = 3;
              break;

            case 8:
              _context10.next = 13;
              break;

            case 10:
              _context10.prev = 10;
              _context10.t1 = _context10["catch"](1);

              _iterator13.e(_context10.t1);

            case 13:
              _context10.prev = 13;

              _iterator13.f();

              return _context10.finish(13);

            case 16:
            case "end":
              return _context10.stop();
          }
        }
      }, refiner, null, [[1, 10, 13, 16]]);
    })
  });
}

function literal(constant) {
  var description = print(constant);
  var t = typeof constant;
  return new Struct({
    type: 'literal',
    schema: t === 'string' || t === 'number' || t === 'boolean' ? constant : null,
    validator: function validator(value) {
      return value === constant || "Expected the literal `" + description + "`, but received: " + print(value);
    }
  });
}

function map(Key, Value) {
  return new Struct({
    type: 'map',
    schema: null,
    entries: /*#__PURE__*/_regeneratorRuntime.mark(function entries(value) {
      var _iterator14, _step14, _step14$value, k, v;

      return _regeneratorRuntime.wrap(function entries$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              if (!(Key && Value && value instanceof Map)) {
                _context11.next = 20;
                break;
              }

              _iterator14 = _createForOfIteratorHelper(value.entries());
              _context11.prev = 2;

              _iterator14.s();

            case 4:
              if ((_step14 = _iterator14.n()).done) {
                _context11.next = 12;
                break;
              }

              _step14$value = _slicedToArray(_step14.value, 2), k = _step14$value[0], v = _step14$value[1];
              _context11.next = 8;
              return [k, k, Key];

            case 8:
              _context11.next = 10;
              return [k, v, Value];

            case 10:
              _context11.next = 4;
              break;

            case 12:
              _context11.next = 17;
              break;

            case 14:
              _context11.prev = 14;
              _context11.t0 = _context11["catch"](2);

              _iterator14.e(_context11.t0);

            case 17:
              _context11.prev = 17;

              _iterator14.f();

              return _context11.finish(17);

            case 20:
            case "end":
              return _context11.stop();
          }
        }
      }, entries, null, [[2, 14, 17, 20]]);
    }),
    coercer: function coercer(value) {
      return value instanceof Map ? new Map(value) : value;
    },
    validator: function validator(value) {
      return value instanceof Map || "Expected a `Map` object, but received: " + print(value);
    }
  });
}
/**
 * Ensure that no value ever passes validation.
 */


function never() {
  return define('never', function () {
    return false;
  });
}
/**
 * Augment an existing struct to allow `null` values.
 */


function nullable(struct) {
  return new Struct(_objectSpread(_objectSpread({}, struct), {}, {
    validator: function validator(value, ctx) {
      return value === null || struct.validator(value, ctx);
    },
    refiner: function refiner(value, ctx) {
      return value === null || struct.refiner(value, ctx);
    }
  }));
}
/**
 * Ensure that a value is a number.
 */


function number() {
  return define('number', function (value) {
    return typeof value === 'number' && !isNaN(value) || "Expected a number, but received: " + print(value);
  });
}

function object(schema) {
  var knowns = schema ? Object.keys(schema) : [];
  var Never = never();
  return new Struct({
    type: 'object',
    schema: schema ? schema : null,
    entries: /*#__PURE__*/_regeneratorRuntime.mark(function entries(value) {
      var unknowns, _iterator15, _step15, key, _iterator16, _step16, _key2;

      return _regeneratorRuntime.wrap(function entries$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              if (!(schema && isObject(value))) {
                _context12.next = 37;
                break;
              }

              unknowns = new Set(Object.keys(value));
              _iterator15 = _createForOfIteratorHelper(knowns);
              _context12.prev = 3;

              _iterator15.s();

            case 5:
              if ((_step15 = _iterator15.n()).done) {
                _context12.next = 12;
                break;
              }

              key = _step15.value;
              unknowns.delete(key);
              _context12.next = 10;
              return [key, value[key], schema[key]];

            case 10:
              _context12.next = 5;
              break;

            case 12:
              _context12.next = 17;
              break;

            case 14:
              _context12.prev = 14;
              _context12.t0 = _context12["catch"](3);

              _iterator15.e(_context12.t0);

            case 17:
              _context12.prev = 17;

              _iterator15.f();

              return _context12.finish(17);

            case 20:
              _iterator16 = _createForOfIteratorHelper(unknowns);
              _context12.prev = 21;

              _iterator16.s();

            case 23:
              if ((_step16 = _iterator16.n()).done) {
                _context12.next = 29;
                break;
              }

              _key2 = _step16.value;
              _context12.next = 27;
              return [_key2, value[_key2], Never];

            case 27:
              _context12.next = 23;
              break;

            case 29:
              _context12.next = 34;
              break;

            case 31:
              _context12.prev = 31;
              _context12.t1 = _context12["catch"](21);

              _iterator16.e(_context12.t1);

            case 34:
              _context12.prev = 34;

              _iterator16.f();

              return _context12.finish(34);

            case 37:
            case "end":
              return _context12.stop();
          }
        }
      }, entries, null, [[3, 14, 17, 20], [21, 31, 34, 37]]);
    }),
    validator: function validator(value) {
      return isObject(value) || "Expected an object, but received: " + print(value);
    },
    coercer: function coercer(value) {
      return isObject(value) ? _objectSpread({}, value) : value;
    }
  });
}
/**
 * Augment a struct to allow `undefined` values.
 */


function optional(struct) {
  return new Struct(_objectSpread(_objectSpread({}, struct), {}, {
    validator: function validator(value, ctx) {
      return value === undefined || struct.validator(value, ctx);
    },
    refiner: function refiner(value, ctx) {
      return value === undefined || struct.refiner(value, ctx);
    }
  }));
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */


function record(Key, Value) {
  return new Struct({
    type: 'record',
    schema: null,
    entries: /*#__PURE__*/_regeneratorRuntime.mark(function entries(value) {
      var k, v;
      return _regeneratorRuntime.wrap(function entries$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              if (!isObject(value)) {
                _context13.next = 11;
                break;
              }

              _context13.t0 = _regeneratorRuntime.keys(value);

            case 2:
              if ((_context13.t1 = _context13.t0()).done) {
                _context13.next = 11;
                break;
              }

              k = _context13.t1.value;
              v = value[k];
              _context13.next = 7;
              return [k, k, Key];

            case 7:
              _context13.next = 9;
              return [k, v, Value];

            case 9:
              _context13.next = 2;
              break;

            case 11:
            case "end":
              return _context13.stop();
          }
        }
      }, entries);
    }),
    validator: function validator(value) {
      return isObject(value) || "Expected an object, but received: " + print(value);
    }
  });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */


function regexp() {
  return define('regexp', function (value) {
    return value instanceof RegExp;
  });
}

function set(Element) {
  return new Struct({
    type: 'set',
    schema: null,
    entries: /*#__PURE__*/_regeneratorRuntime.mark(function entries(value) {
      var _iterator17, _step17, v;

      return _regeneratorRuntime.wrap(function entries$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              if (!(Element && value instanceof Set)) {
                _context14.next = 18;
                break;
              }

              _iterator17 = _createForOfIteratorHelper(value);
              _context14.prev = 2;

              _iterator17.s();

            case 4:
              if ((_step17 = _iterator17.n()).done) {
                _context14.next = 10;
                break;
              }

              v = _step17.value;
              _context14.next = 8;
              return [v, v, Element];

            case 8:
              _context14.next = 4;
              break;

            case 10:
              _context14.next = 15;
              break;

            case 12:
              _context14.prev = 12;
              _context14.t0 = _context14["catch"](2);

              _iterator17.e(_context14.t0);

            case 15:
              _context14.prev = 15;

              _iterator17.f();

              return _context14.finish(15);

            case 18:
            case "end":
              return _context14.stop();
          }
        }
      }, entries, null, [[2, 12, 15, 18]]);
    }),
    coercer: function coercer(value) {
      return value instanceof Set ? new Set(value) : value;
    },
    validator: function validator(value) {
      return value instanceof Set || "Expected a `Set` object, but received: " + print(value);
    }
  });
}
/**
 * Ensure that a value is a string.
 */


function string() {
  return define('string', function (value) {
    return typeof value === 'string' || "Expected a string, but received: " + print(value);
  });
}

function tuple(Elements) {
  var Never = never();
  return new Struct({
    type: 'tuple',
    schema: null,
    entries: /*#__PURE__*/_regeneratorRuntime.mark(function entries(value) {
      var length, i;
      return _regeneratorRuntime.wrap(function entries$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              if (!Array.isArray(value)) {
                _context15.next = 9;
                break;
              }

              length = Math.max(Elements.length, value.length);
              i = 0;

            case 3:
              if (!(i < length)) {
                _context15.next = 9;
                break;
              }

              _context15.next = 6;
              return [i, value[i], Elements[i] || Never];

            case 6:
              i++;
              _context15.next = 3;
              break;

            case 9:
            case "end":
              return _context15.stop();
          }
        }
      }, entries);
    }),
    validator: function validator(value) {
      return Array.isArray(value) || "Expected an array, but received: " + print(value);
    }
  });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */


function type(schema) {
  var keys = Object.keys(schema);
  return new Struct({
    type: 'type',
    schema: schema,
    entries: /*#__PURE__*/_regeneratorRuntime.mark(function entries(value) {
      var _iterator18, _step18, k;

      return _regeneratorRuntime.wrap(function entries$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              if (!isObject(value)) {
                _context16.next = 18;
                break;
              }

              _iterator18 = _createForOfIteratorHelper(keys);
              _context16.prev = 2;

              _iterator18.s();

            case 4:
              if ((_step18 = _iterator18.n()).done) {
                _context16.next = 10;
                break;
              }

              k = _step18.value;
              _context16.next = 8;
              return [k, value[k], schema[k]];

            case 8:
              _context16.next = 4;
              break;

            case 10:
              _context16.next = 15;
              break;

            case 12:
              _context16.prev = 12;
              _context16.t0 = _context16["catch"](2);

              _iterator18.e(_context16.t0);

            case 15:
              _context16.prev = 15;

              _iterator18.f();

              return _context16.finish(15);

            case 18:
            case "end":
              return _context16.stop();
          }
        }
      }, entries, null, [[2, 12, 15, 18]]);
    }),
    validator: function validator(value) {
      return isObject(value) || "Expected an object, but received: " + print(value);
    }
  });
}

function union(Structs) {
  var description = Structs.map(function (s) {
    return s.type;
  }).join(' | ');
  return new Struct({
    type: 'union',
    schema: null,
    validator: function validator(value, ctx) {
      var failures = [];

      var _iterator19 = _createForOfIteratorHelper(Structs),
          _step19;

      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var S = _step19.value;

          var _run = run(value, S, ctx),
              _run2 = _toArray(_run),
              tuples = _run2.slice(0);

          var _tuples = _slicedToArray(tuples, 1),
              first = _tuples[0];

          if (!first[0]) {
            return [];
          } else {
            var _iterator20 = _createForOfIteratorHelper(tuples),
                _step20;

            try {
              for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
                var _step20$value = _slicedToArray(_step20.value, 1),
                    failure = _step20$value[0];

                if (failure) {
                  failures.push(failure);
                }
              }
            } catch (err) {
              _iterator20.e(err);
            } finally {
              _iterator20.f();
            }
          }
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }

      return ["Expected the value to satisfy a union of `" + description + "`, but received: " + print(value)].concat(failures);
    }
  });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */


function unknown() {
  return define('unknown', function () {
    return true;
  });
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */


function coerce(struct, condition, _coercer) {
  return new Struct(_objectSpread(_objectSpread({}, struct), {}, {
    coercer: function coercer(value, ctx) {
      return _is(value, condition) ? struct.coercer(_coercer(value, ctx), ctx) : struct.coercer(value, ctx);
    }
  }));
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */


function defaulted(struct, fallback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return coerce(struct, unknown(), function (x) {
    var f = typeof fallback === 'function' ? fallback() : fallback;

    if (x === undefined) {
      return f;
    }

    if (!options.strict && isPlainObject(x) && isPlainObject(f)) {
      var ret = _objectSpread({}, x);

      var changed = false;

      for (var key in f) {
        if (ret[key] === undefined) {
          ret[key] = f[key];
          changed = true;
        }
      }

      if (changed) {
        return ret;
      }
    }

    return x;
  });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */


function trimmed(struct) {
  return coerce(struct, string(), function (x) {
    return x.trim();
  });
}
/**
 * Ensure that a string, array, map, or set is empty.
 */


function empty(struct) {
  var expected = "Expected an empty " + struct.type;
  return refine(struct, 'empty', function (value) {
    if (value instanceof Map || value instanceof Set) {
      var _size = value.size;
      return _size === 0 || expected + " but received one with a size of `" + _size + "`";
    } else {
      var length = value.length;
      return length === 0 || expected + " but received one with a length of `" + length + "`";
    }
  });
}
/**
 * Ensure that a number or date is below a threshold.
 */


function max(struct, threshold) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var exclusive = options.exclusive;
  return refine(struct, 'max', function (value) {
    return exclusive ? value < threshold : value <= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? '' : 'or equal to ') + threshold + " but received `" + value + "`";
  });
}
/**
 * Ensure that a number or date is above a threshold.
 */


function min(struct, threshold) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var exclusive = options.exclusive;
  return refine(struct, 'min', function (value) {
    return exclusive ? value > threshold : value >= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? '' : 'or equal to ') + threshold + " but received `" + value + "`";
  });
}
/**
 * Ensure that a string matches a regular expression.
 */


function pattern(struct, regexp) {
  return refine(struct, 'pattern', function (value) {
    return regexp.test(value) || "Expected a " + struct.type + " matching `/" + regexp.source + "/` but received \"" + value + "\"";
  });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */


function size(struct, min) {
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : min;
  var expected = "Expected a " + struct.type;
  var of = min === max ? "of `" + min + "`" : "between `" + min + "` and `" + max + "`";
  return refine(struct, 'size', function (value) {
    if (typeof value === 'number' || value instanceof Date) {
      return min <= value && value <= max || expected + " " + of + " but received `" + value + "`";
    } else if (value instanceof Map || value instanceof Set) {
      var _size2 = value.size;
      return min <= _size2 && _size2 <= max || expected + " with a size " + of + " but received one with a size of `" + _size2 + "`";
    } else {
      var length = value.length;
      return min <= length && length <= max || expected + " with a length " + of + " but received one with a length of `" + length + "`";
    }
  });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */


function refine(struct, name, refiner) {
  return new Struct(_objectSpread(_objectSpread({}, struct), {}, {
    refiner: function (_refiner) {
      var _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(refiner);

      function refiner(_x, _x2) {
        var _args17 = arguments;
        return _regeneratorRuntime.wrap(function refiner$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.delegateYield(_refiner.apply(this, _args17), "t0", 1);

              case 1:
                return _context17.abrupt("return", _context17.t0);

              case 2:
              case "end":
                return _context17.stop();
            }
          }
        }, _marked3, this);
      }

      refiner.toString = function () {
        return _refiner.toString();
      };

      return refiner;
    }( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(value, ctx) {
      var result, failures, _iterator21, _step21, failure;

      return _regeneratorRuntime.wrap(function _callee3$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.delegateYield(struct.refiner(value, ctx), "t0", 1);

            case 1:
              result = refiner(value, ctx);
              failures = toFailures(result, ctx, struct, value);
              _iterator21 = _createForOfIteratorHelper(failures);
              _context18.prev = 4;

              _iterator21.s();

            case 6:
              if ((_step21 = _iterator21.n()).done) {
                _context18.next = 12;
                break;
              }

              failure = _step21.value;
              _context18.next = 10;
              return _objectSpread(_objectSpread({}, failure), {}, {
                refinement: name
              });

            case 10:
              _context18.next = 6;
              break;

            case 12:
              _context18.next = 17;
              break;

            case 14:
              _context18.prev = 14;
              _context18.t1 = _context18["catch"](4);

              _iterator21.e(_context18.t1);

            case 17:
              _context18.prev = 17;

              _iterator21.f();

              return _context18.finish(17);

            case 20:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee3, null, [[4, 14, 17, 20]]);
    }))
  }));
}

export { Struct, StructError, any, array, _assert as assert, assign, boolean, coerce, _create as create, date, defaulted, define, deprecated, dynamic, empty, enums, func, instance, integer, intersection, _is as is, lazy, literal, map, _mask as mask, max, min, never, nullable, number, object, omit, optional, partial, pattern, pick, record, refine, regexp, set, size, string, struct, trimmed, tuple, type, union, unknown, _validate as validate };